// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.certext

import org.multipaz.cbor.DataItem
import org.multipaz.certext.MultipazExtension
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.certext.CloudKeyAttestation
import org.multipaz.certext.GoogleAccount
import org.multipaz.certext.toDataItem
import org.multipaz.certext.fromDataItem

fun MultipazExtension.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "YegmW_UH9FcfUKeuIGUvQrR09IPU7lbWQsZtU51wCUI")
val MultipazExtension_cborSchemaId = ByteString(97, -24, 38, 91, -11, 7, -12, 87, 31, 80, -89, -82, 32, 101, 47, 66, -76, 116, -12, -125, -44, -18, 86, -42, 66, -58, 109, 83, -99, 112, 9, 66)

fun MultipazExtension.Companion.fromCbor(data: ByteArray): MultipazExtension {
    return MultipazExtension.fromDataItem(Cbor.decode(data))
}

val MultipazExtension.Companion.cborSchemaId: ByteString
    get() = MultipazExtension_cborSchemaId

fun MultipazExtension.toDataItem(): DataItem {
    val builder = CborMap.builder()
    val cloudKeyAttestation = this.cloudKeyAttestation
    if (cloudKeyAttestation != null) {
        builder.put("cloudKeyAttestation", cloudKeyAttestation.toDataItem())
    }
    val googleAccount = this.googleAccount
    if (googleAccount != null) {
        builder.put("googleAccount", googleAccount.toDataItem())
    }
    return builder.end().build()
}

fun MultipazExtension.Companion.fromDataItem(dataItem: DataItem): MultipazExtension {
    val cloudKeyAttestation0 = if (dataItem.hasKey("cloudKeyAttestation")) {
        CloudKeyAttestation.fromDataItem(dataItem["cloudKeyAttestation"])
    } else {
        null
    }
    val googleAccount0 = if (dataItem.hasKey("googleAccount")) {
        GoogleAccount.fromDataItem(dataItem["googleAccount"])
    } else {
        null
    }
    return MultipazExtension(
        cloudKeyAttestation = cloudKeyAttestation0,
        googleAccount = googleAccount0,
    )
}
